@if (alertService.alertMessage) {
  <mat-toolbar
    color="warn"
    @easeInOutGroup
    class="mat-elevation-z4"
    >
    @if (alertService.alertMessage) {
      <mat-toolbar-row @easeInOutRow>
        <span class="alert-content-truncate">{{ alertService.alertMessage }}</span>
        <button mat-icon-button (click)="alertService.remove()">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-toolbar-row>
    }
  </mat-toolbar>
}
